import {shopModule} from '../../module.js';

shopModule.directive('nsvisible', ['$animate', function($animate) {
    function lowercase(string){
        return typeof string === 'string' ? string.toLowerCase() : string;
    }

    function toBoolean(value) {
        if (typeof value === 'function') {
            value = true;
        } else if (value && value.length !== 0) {
            let v = lowercase("" + value);
            value = !(v == 'f' || v == '0' || v == 'false' || v == 'no' || v == 'n' || v == '[]');
        } else {
            value = false;
        }
        return value;
    }

    return function(scope, element, attr) {
        scope.$watch(attr.nsvisible, function watchAction(value) {
            $animate[toBoolean(value) ? 'removeClass' : 'addClass'](element, 'element-is-hidden');
        });
    }
}]);
